var _defs, _g, _g2, _ellipse, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 720",
    role: "img",
    "aria-label": "ChatBizz AI assistant robot waving",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "50%",
    cy: "46%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9cc9ff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f9bff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "white",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f1f6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cddcf1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whiteSide",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4e2f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cc0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c78ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ball",
    cx: "35%",
    cy: "30%",
    r: "75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9e4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#3a9bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f5ee0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "visor",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22345f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0d1a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cup",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c5388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121f45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyan",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5fd7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9df0ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft2",
    x: "-30%",
    y: "-80%",
    width: "160%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "neon",
    x: "-40%",
    y: "-80%",
    width: "180%",
    height: "260%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "drop",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 9,
    floodColor: "#0b3a8c",
    floodOpacity: 0.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#soft)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 350,
    rx: 250,
    ry: 290,
    fill: "url(#glow)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 170,
    rx: 90,
    ry: 150,
    fill: "#6ea8ff",
    opacity: 0.35,
    transform: "rotate(-20 120 170)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 500,
    cy: 560,
    rx: 100,
    ry: 140,
    fill: "#3d8bff",
    opacity: 0.35,
    transform: "rotate(25 500 560)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 470,
    cy: 150,
    rx: 70,
    ry: 110,
    fill: "#ffffff",
    opacity: 0.55,
    transform: "rotate(15 470 150)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 330 l7 18 l18 7 l-18 7 l-7 18 l-7 -18 l-18 -7 l18 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528 300 l5 13 l13 5 l-13 5 l-5 13 l-5 -13 l-13 -5 l13 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498 90 l4 10 l10 4 l-10 4 l-4 10 l-4 -10 l-10 -4 l10 -4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 560,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 450,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 80,
    r: 4
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300,
    cy: 676,
    rx: 118,
    ry: 15,
    fill: "#0a47b8",
    opacity: 0.28,
    filter: "url(#soft2)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#drop)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250 600 q-8 38 22 46 q34 8 44 -20 q4 -22 -14 -34z",
    fill: "url(#white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318 590 q10 28 40 24 q26 -6 20 -30 q-6 -16 -26 -18z",
    fill: "url(#white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 450 q-14 96 40 150 q38 26 80 -4 q50 -52 38 -146z",
    fill: "url(#white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 452 Q172 440 140 396",
    stroke: "url(#blue)",
    strokeWidth: 42,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 452 Q172 440 140 396",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.25,
    transform: "translate(-6 -8)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100 368) rotate(-24) scale(1.35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18 q-6 -26 14 -30 q10 -2 14 8 q10 -14 22 -4 q8 10 -2 26 q10 4 6 18 q-6 20 -34 18 q-24 -4 -20 -36z",
    fill: "url(#white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 -8 q4 -12 14 -8 M34 0 q8 -8 16 0",
    stroke: "#cfdcf1",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378 456 Q412 484 392 524",
    stroke: "url(#blue)",
    strokeWidth: 40,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 386,
    cy: 532,
    rx: 30,
    ry: 26,
    fill: "url(#white)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 430 Q300 392 386 430 Q376 486 300 520 Q224 486 214 430z",
    fill: "url(#blue)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 436 Q300 408 368 436",
    stroke: "#fff",
    strokeWidth: 5,
    fill: "none",
    opacity: 0.35,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 118,
    width: 376,
    height: 282,
    rx: 118,
    fill: "url(#white)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 118,
    width: 376,
    height: 282,
    rx: 118,
    fill: "url(#whiteSide)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 168 Q170 128 250 124",
    stroke: "#fff",
    strokeWidth: 10,
    strokeLinecap: "round",
    fill: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 110,
    cy: 262,
    rx: 34,
    ry: 64,
    fill: "url(#cup)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102,
    cy: 262,
    rx: 19,
    ry: 42,
    fill: "none",
    stroke: "url(#cyan)",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 490,
    cy: 262,
    rx: 34,
    ry: 64,
    fill: "url(#cup)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 498,
    cy: 262,
    rx: 19,
    ry: 42,
    fill: "none",
    stroke: "url(#cyan)",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 162,
    width: 300,
    height: 192,
    rx: 84,
    fill: "url(#visor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 162,
    width: 300,
    height: 192,
    rx: 84,
    fill: "none",
    stroke: "#2c4378",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 190 Q300 168 410 190 Q420 204 400 208 Q300 192 200 208 Q180 204 190 190z",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#cyan)",
    strokeWidth: 10,
    strokeLinecap: "round",
    fill: "none",
    filter: "url(#neon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204 262 Q236 222 268 262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 262 Q364 222 396 262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 296 Q300 324 332 296"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 96,
    width: 8,
    height: 30,
    rx: 4,
    fill: "#243559"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 76,
    r: 30,
    fill: "url(#ball)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 289,
    cy: 64,
    rx: 10,
    ry: 7,
    fill: "#fff",
    opacity: 0.7,
    transform: "rotate(-30 289 64)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthRobot);
export default __webpack_public_path__ + "static/media/auth-robot.73482235169b21d27a9679c18150fd1c.svg";
export { ForwardRef as ReactComponent };